import { render, staticRenderFns } from "./analizcomp.vue?vue&type=template&id=0d34b956&"
import script from "./analizcomp.vue?vue&type=script&lang=js&"
export * from "./analizcomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports